import { AuthConfig } from 'app/Core/Funcionalidade/Auth/AuthConfig';
import { ChaveConfig } from 'app/Core/Funcionalidade/Chave/ChaveConfig';
import { ConteudoConfig } from 'app/Core/Funcionalidade/Conteudo/ConteudoConfig';
import { EmpresaBloqueioConfig } from 'app/Core/Funcionalidade/EmpresaBloqueio/EmpresaBloqueioConfig';
import { FaqConfig } from 'app/Core/Funcionalidade/Faq/FaqConfig';
import { HelpConfig } from 'app/Core/Funcionalidade/Help/HelpConfig';
import { CriarEmpresaConfig } from 'app/Core/Funcionalidade/CriarEmpresa/CriarEmpresaConfig';
import { RelatorioConfig } from 'app/Relatorio/RelatorioConfig';
import { AreaClienteConfig } from './Core/Funcionalidade/AreaCliente/AreaClienteConfig';
import { DadosEmpresaConfig } from './Core/Funcionalidade/DadosEmpresa/DadosEmpresaConfig';
import { ERPAppConfig } from './ERP/ERPAppConfig';
import { FuncionarioConfig } from './ERP/Funcionario/FuncionarioConfig';
import { MarketplaceConfig } from './Marketplace/MarketplaceConfig';
import { SetupEmpresasConfig } from './Core/Funcionalidade/SetupEmpresas/SetupEmpresasConfig'
import { ComunicadorConfig } from "./Core/Funcionalidade/Comunicador/ComunicadorConfig";
import { ComponentHomologConfig } from "./Core/Funcionalidade/ComponentHomolog/ComponentHomologConfig";

export const appsConfigs = [
    ERPAppConfig,
    HelpConfig,
    FaqConfig,
    AuthConfig,
    RelatorioConfig,
    CriarEmpresaConfig,
    EmpresaBloqueioConfig,
    ChaveConfig,
    FuncionarioConfig,
    ConteudoConfig,
    MarketplaceConfig,
    DadosEmpresaConfig,
    AreaClienteConfig,
    SetupEmpresasConfig,
    ComunicadorConfig,
    ComponentHomologConfig,
];
